import { ProductListComponent } from './product-list.component';

export default ProductListComponent;
